<!--直播详情--->
<!--wj-->
<template>
  <div class="lcDetail tsdetail">
    <detail-title></detail-title>
    <div class="lc-detail">
      <img :src="chapter.cPic" style="width: 100vw; height: 56.25vw" />
      <div class="chapter-back" @click="liveRoom(chapter.cStatus, $event)">
        <div class="chapter-back1" v-if="chapter.cStatus == '直播中'">
          <img src="../assets/image/video.svg" style="width: 4rem" />
          <div
            style="
              width: 100vw;
              display: flex;
              justify-content: center;
              padding-top: 1vw;
            "
          >
            <lottie
              :options="defaultOptions"
              class="chapter-anim"
              :width="27"
              :height="20"
              v-on:animCreated="handleAnimation"
            />
            <span style="color: #ffffff">直播中</span>
          </div>
        </div>
        <div
          class="chapter-back2"
          v-if="chapter.cStatus == '未开播' || chapter.cStatus == '待开播'"
        >
          <p class="chapter-p">直播未开始</p>
          <p>
            <span class="chapter-span">{{ tip }}</span>
          </p>
        </div>
        <div class="chapter-back2" v-if="chapter.cStatus == '回放'">
          <p class="chapter-p">直播已结束</p>
          <p><span class="chapter-span">回放</span></p>
        </div>
        <div class="chapter-back2" v-if="chapter.cStatus == '已结束'">
          <p class="chapter-p">直播已结束</p>
          <p><span class="chapter-span">已结束</span></p>
        </div>
      </div>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
      style="width: 100%"
      center
    >
      <el-tab-pane label="介绍" name="first">
        <div class="lc-tab1">
          <p class="offline-title">
            <strong>{{ chapter.cName }}</strong>
          </p>
          <p class="tab1-p">
            <span>{{ chapter.cTech }}</span>
            <el-divider direction="vertical"></el-divider>
            <span v-if="chapter.cStatus == '直播中'"
              >{{ chapter.cStudyNum + chapter.cStudyNums }}人正在学习</span
            >
            <span
              v-if="chapter.cStatus == '未开播' || chapter.cStatus == '待开播'"
              >{{ chapter.cReserveNum + chapter.cReserveNums }}人已预约</span
            >
            <span
              v-if="chapter.cStatus == '回放' || chapter.cStatus == '已结束'"
              >{{ chapter.cStudyNum + chapter.cStudyNums }}人已学习</span
            >
            <span style="float: right">开播时间：{{ chapter.cStartTime }}</span>
          </p>
        </div>
        <div class="tsd-line"></div>
        <p class="offline-jj"><strong>课程简介</strong></p>
        <div class="offline-detail">
          <p v-html="course.tslcDesc"></p>
        </div>
        <div class="tsd-line"></div>
        <p class="offline-jj" v-if="tech"><strong>授课讲师</strong></p>
        <div class="tech-live" v-if="tech" v-for="item in tech">
          <el-row>
            <el-col :span="3">
              <img :src="item.photo" :onerror="tslogo" class="tstt-logo" />
            </el-col>
            <el-col :span="21">
              <p class="zj-name" style="padding-bottom: 0.5rem">
                {{ item.nickname }}
              </p>
              <div class="ex-col" v-for="items in item.actor" :key="items">
                {{ items }}
              </div>
            </el-col>
          </el-row>
          <p
            :class="item.tstt ? 'tstt-name' : 'tstt-nana'"
            v-html="item.description"
          >
            {{ item.description }}
          </p>
          <p class="tstt-more" v-if="item.desclength">
            <span @click="More(item)" v-if="item.tstt"
              >展开<i class="el-icon-arrow-down"></i
            ></span>
            <span @click="Less(item)" v-if="!item.tstt"
              >收起<i class="el-icon-arrow-up"></i
            ></span>
          </p>
        </div>
      </el-tab-pane>
      <el-tab-pane label="目录" name="second">
        <div class="listpic">
          <div class="tc-col" v-for="item in list" :key="item.cId">
            <el-col :span="3">
              <div class="ts-p" v-if="item.cStatus == '回放'">
                {{ item.cStatus }}
              </div>
              <div
                class="ts-pp"
                v-if="
                  item.cStatus == '待开播' ||
                  item.cStatus == '未开播' ||
                  item.cStatus == '已结束'
                "
              >
                {{ item.cStatus }}
              </div>
              <div class="ts-ppp" v-if="item.cStatus == '直播中'">
                {{ item.cStatus }}
              </div>
            </el-col>
            <el-col :span="16" @click.native="tsDetail(item)">
              <div
                class="listpic-p"
                :class="{ 'tsd-choose': choose == item.cId }"
                style="padding-left: 1rem"
              >
                {{ item.cNum + item.cName }}
              </div>
            </el-col>
            <el-col :span="5" class="lc-free">
              <div class="listpic-i">
                <span class="cIsFree" v-if="!item.cIsFree">
                  <img src="../assets/image/suo.svg" style="width: 1.5rem" />
                </span>
              </div>
            </el-col>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="评价" name="third">
        <div class="Evaluate">
          <p class="Evaluate-p"><strong>我的评价</strong></p>
          <el-rate
            v-model="value"
            show-text
            class="Evaluate-rate"
            :texts="texts"
            disabled
          >
          </el-rate>
          <p class="rate-pj">您的宝贵评价，对我们非常重要哦~</p>
        </div>
        <div class="tsd-line"></div>
        <div class="Evaluate">
          <p class="Evaluate-p"><strong>全部评价</strong></p>
          <el-row
            style="
              border-bottom: 1px solid rgb(230, 232, 232);
              padding-bottom: 1rem;
            "
          >
            <el-col :span="6" class="totalRating">
              <span class="span1"
                ><strong>{{ totalRating }}</strong></span
              ><span class="span2"><strong>星</strong></span>
            </el-col>
            <el-col :span="6" class="percet-col">
              <el-rate
                v-for="(t, index) in percentList"
                :key="index"
                v-model="t.star"
                :disabled="true"
                :colors="colors"
                :disabled-void-icon-class="classoff"
              ></el-rate>
            </el-col>
            <el-col :span="12">
              <el-progress
                v-for="(m, index) in percentList"
                :key="index"
                :percentage="m.percent"
                status="warning"
                :show-text="false"
                :disabled="true"
                :color="colors"
              ></el-progress>
            </el-col>
          </el-row>
          <el-row
            style="border-bottom: 1px solid rgb(230, 232, 232); padding: 1rem 0"
            v-for="item in ratingList"
            :key="item.rId"
            v-if="item.umbi"
          >
            <el-col :span="12">
              <img
                :src="item.umbi.umbiLogo"
                :onerror="tslogo"
                class="rate-img"
              /><span style="font-size: 1.25rem">{{ item.umbi.umbiName }}</span>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <p class="percet-col">
                <el-rate
                  v-model="item.rStar"
                  :disabled="true"
                  :colors="colors"
                  :disabled-void-icon-class="classoff"
                ></el-rate>
              </p>
              <p style="padding-top: 0.5rem; color: #969696">
                {{ item.rDate }}
              </p>
            </el-col>
          </el-row>
        </div>
      </el-tab-pane>
    </el-tabs>
    <transition name="fade">
      <el-row class="Offline-footer">
        <el-col :span="8">
          <p class="off-fire"><strong>免费</strong></p>
          <p style="color: #969696" v-if="chapter.cStatus == '直播中'">
            {{ chapter.cStudyNum + chapter.cStudyNums }}人正在学习
          </p>
          <p
            style="color: #969696"
            v-if="chapter.cStatus == '未开播' || chapter.cStatus == '待开播'"
          >
            {{ chapter.cReserveNum + chapter.cReserveNums }}人已预约
          </p>
          <p
            style="color: #969696"
            v-if="chapter.cStatus == '回放' || chapter.cStatus == '已结束'"
          >
            {{ chapter.cStudyNum + chapter.cStudyNums }}人已学习
          </p>
        </el-col>
        <el-col :span="8" class="off-zixun">
          <a :href="'tel:' + phone"
            ><img class="Off-tel" src="@/assets/image/tell3.svg" />咨询</a
          >
          <span style="color: rgb(230, 232, 232)">|</span>
        </el-col>
        <el-col :span="8">
          <button
            type="button"
            v-if="
              chapter.cStatus == '直播中' ||
              chapter.cStatus == '未开播' ||
              chapter.cStatus == '待开播'
            "
            class="Offline-btn2"
            @click="OpenStore()"
          >
            前往app观看
          </button>
          <button
            type="button"
            v-if="chapter.cStatus == '回放'"
            class="Offline-btn"
            @click="LiveBack()"
          >
            回放
          </button>
          <button
            type="button"
            v-if="chapter.cStatus == '已结束'"
            class="Offline-btn3"
          >
            已结束
          </button>
        </el-col>
      </el-row>
    </transition>
    <share-wechat></share-wechat>
  </div>
</template>
<script>
import Lottie from "vue-lottie";
import Anim from "@/assets/lottie/living.json";
import Axios from "axios";
import { eventBus } from '@/assets/js/eventBus';
import ShareWechat from "@/components/ShareWechat";
import DetailTitle from "@/components/DetailTitle";
// var curdate = require("@/assets/js/splice.js");
export default {
  data() {
    return {
      cId: "",
      list: [],
      chapter: [],
      activeName: "first",
      tech: [],
      course: [],
      tslogo: 'this.src="' + require("@/assets/image/tx3.svg") + '"', //专家默认图片
      choose: "",
      value: null, //我的评分
      texts: ["极差", "差", "中评", "良好", "推荐"],
      umuId: "",
      m: true,
      star1: null,
      percentList: [],
      totalRating: "0.0",
      colors: ["#F7BA2A", "#F7BA2A", "#F7BA2A"],
      classoff: "el-icon-star-off",
      ratingList: [],
      defaultOptions: { animationData: Anim, loop: true, autoplay: true },
      defaultAnim: "",
      phone: "400-829-6689",
      tip: "立即预约",
    };
  },
  components: {
    Lottie,
    DetailTitle,
    ShareWechat
  },
  mounted() {
    const that = this;
    if (that.$route.query.cId) {
      that.cId = that.$route.query.cId;
    } else {
      var id = "";
      var locations = location.href;
      if (locations.indexOf("?") != -1) {
        //判断是否有参数
        if (locations.indexOf("from") != -1) {
          var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
          var strs = str.split("?");
          id = strs[2];
        } else {
          var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
          var strs = str.split("?");
          id = strs[1]; //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        }
      }
      that.cId = id.split("=")[1];
    }
    that.getList(that.cId);
  },
  methods: {
    //动图
    handleAnimation(anim) {
      this.defaultAnim = anim;
    },
    //获取数据
    getList(id) {
      const that = this;
      Axios.get(
        that.$store.state.APIURLS + "Course/getCourseDesc?cId=" + id
      ).then(function (res) {
        if (res.data.code == 200) {
          res.data.data.chapter.cStartTime =
            res.data.data.chapter.cStartTime.substr(5, 11);
          if (res.data.data.tech) {
            res.data.data.tech.forEach((e) => {
              if (e.actor) {
                e.actor = e.actor.split(",").slice(0, 3);
              }
              if (e.description.length >= 65) {
                e.desclength = true;
                e.tstt = true;
              } else {
                e.desclength = false;
                e.tstt = true;
              }
            });
          }
          that.tech = res.data.data.tech;
          that.course = res.data.data.course;
          that.chapter = res.data.data.chapter;
          var shareList = {
            title: res.data.data.chapter.cName,
            content: res.data.data.course.tslcDesc,
          };
          eventBus.$emit("shareList", shareList);
        }
      });
    },
    //tab切换
    handleClick(tab, event) {
      const that = this;
      if (that.activeName == "second") {
        that.getCourse(that.chapter.tslcId);
      } else if (that.activeName == "third") {
        that.getEvaluate(that.chapter.tslcId);
      } else {
        that.getList(that.cId);
      }
    },
    //获取目录信息
    getCourse(id) {
      const that = this;
      that.choose = that.cId;
      Axios.get(
        that.$store.state.APIURLS + "Course/getCourseCatalog?tslcId=" + id
      ).then(function (res) {
        if (res.data.code == 200) {
          that.list = res.data.data;
        }
      });
    },
    //获取评价信息
    getEvaluate(id) {
      const that = this;
      const param = {
        tslcId: id,
        umuId: "",
      };
      Axios.post(
        that.$store.state.APIURLS + "Course/getCourseRating",
        param
      ).then(function (res) {
        if (res.data.code == 200) {
          if (res.data.data.myRating) {
            if (res.data.data.myRating.rStar) {
              that.value = res.data.data.myRating.rStar;
              that.m = that.value;
            }
          }
          res.data.data.percentList.forEach((e) => {
            e.star = parseInt(e.star);
            e.percent = parseInt(e.percent * 100);
          });
          res.data.data.ratingList.forEach((e) => {
            e.rDate = e.rDate.substr(0, 10);
          });
          that.percentList = res.data.data.percentList;
          that.totalRating = res.data.data.totalRating;
          that.ratingList = res.data.data.ratingList;
        }
      });
    },
    //更多
    More(m) {
      var that = this;
      m.tstt = false;
    },
    //减少
    Less(m) {
      var that = this;
      m.tstt = true;
    },
    //目录点击事件
    tsDetail(m) {
      const that = this;
      that.choose = m.cId;
      that.cId = m.cId;
      that.getList(that.cId);
    },
    //进入直播间/预约
    liveRoom(m, event) {
      const that = this;
      if (m == "回放") {
        that.LiveBack();
      } else if (m == "已结束") {
        event.cancelBubble = false;
      } else {
        that.$toast({
          message: "请前往APP观看",
          type: "success",
          position: "bottom",
          duration: "2000",
        });
      }
    },
    OpenStore() {
      const that = this;
      location.href = "http://url.cn/59TtsAP";
    },
    //回放
    LiveBack() {
      const that = this;
      if (that.chapter.cIsFree) {
        //免费
        that.$router.push({
          path: "/LiveBack",
          query: {
            cId: that.cId,
            backUrl: that.chapter.backUrl,
            S: that.S,
          },
        });
      } else {
        //收费
        that.$toast({
          message: "请先前往app观看",
          type: "success",
          position: "bottom",
          duration: "2000",
        });
      }
    },
  },
};
</script>